import { Footer, Header } from "@/helpers/header";
import { ConfigContext } from "@/state/configContext";
import { clearFlashMessage, useFlashMessage } from "@/state/flash";
import { mustLoginError, useAppStatus, useConfig } from "@/state/server";
import { Outlet, createFileRoute, useLocation } from "@tanstack/react-router";
import { useEffect, useRef, type ReactNode } from "react";
import { UserLogin } from "@/login";
import { AppContext } from "@/state/appContext";

export const Route = createFileRoute("/_app")({
  component: AppLayoutComponent,
  errorComponent: ErrorComponent,
});

function AppLayoutComponent() {
  return (
    <Layout>
      <Outlet />
    </Layout>
  );
}

function ErrorComponent({ error }: { error: unknown }) {
  if (error) console.log("Error", error);

  return (
    <Layout>
      {error == mustLoginError ? (
        <UserLogin />
      ) : (
        <div>ERROR: {JSON.stringify(error)}</div>
      )}
    </Layout>
  );
}

function Layout({ children }: { children: ReactNode }) {
  const config = useConfig();
  const appStatus = useAppStatus();
  const flash = useFlashMessage();

  const location = useLocation();
  const prevPath = useRef(location.pathname);
  const prevFlash = useRef<unknown>(null);

  useEffect(() => {
    if (prevPath.current !== location.pathname && prevFlash.current == flash) {
      clearFlashMessage();
    }
    prevPath.current = location.pathname;
    prevFlash.current = flash;
  }, [location.pathname, flash]);

  return (
    <>
      <link href="/css/bootstrap.min.css" rel="stylesheet" />
      <link href="/css/fotronica.css" rel="stylesheet" />
      <link href="/css/sitio.css" rel="stylesheet" />
      <div id="body">
        {config.data && appStatus.data ? (
          <ConfigContext value={config.data}>
            <AppContext value={appStatus.data}>
              <Header />
              {flash && (
                <div className={`alert alert-${flash.level}`}>
                  {flash.message.split("<br>").map((l) => (
                    <div>{l}</div>
                  ))}
                </div>
              )}
              {children}
              <Footer />
            </AppContext>
          </ConfigContext>
        ) : (
          "Loading..."
        )}
      </div>
    </>
  );
}
